<template>
    <div>
        <v-dialog v-model="dialog_form" content-class="half-screen-dialog" no-click-animation scrollable persistent transition="slide-y-transition" :max-width="$root.fn_getActionPaneWidth()">
            <v-card no-border-radius grey-back>

              <v-toolbar :height="56" flat>
                  <v-btn icon @click="closeDialog"><v-icon>arrow_back</v-icon></v-btn>
                  <v-toolbar-title>
                    Stock Transfer
                  </v-toolbar-title>
              </v-toolbar>

              <v-divider class="noprint"></v-divider>

              <div class="data-container grey-back">

                <v-progress-linear indeterminate :height="6" color="primary" v-if="$root.dialogLoader || $parent.loading"></v-progress-linear>
                <div center-align class="pa-4 light-opacity-color" v-if="$root.dialogLoader">Syncing master items...</div>

                <div center-align class="pa-4" v-if="$parent.cacheRetry">
                  <v-btn color="primary" capitalize text @click="$parent.fn_resetCache"><v-icon class="mr-2">refresh</v-icon> Reload</v-btn>
                </div>

                <template>
                  <!-- <v-subheader class="mb-2" white-back>Date
                    <v-spacer></v-spacer>
                    <span><u>{{$parent.Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</u></span>
                  </v-subheader> -->
                 <v-list class="pa-0">
                        <v-list-item style="height:36px">
                            <v-list-item-content>
                              <v-list-item-title>
                                  <span cursor-pointer class="text-underline" @click="$parent.fn_openDialogNumberSeries">{{$parent.Form.transactionData.mergeTransactionNumber}}</span>
                              </v-list-item-title>
                            </v-list-item-content>

                            <span v-if="$parent.Form.transactionData.transactionDate">{{$parent.Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</span> 

                            <v-list-item-action class="ml-0">
                                <v-btn icon @click="$parent.fn_openDatePicker('transactionDate', $parent.Form.transactionData.transactionDate)"><v-icon>date_range</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>

                  <ValidationObserver ref="observer">

                      <v-form>

                    

                        <v-layout row wrap ma-0 white-back pt-4 pb-4>
                              <v-flex xs6 sm6 md6 form-item pt-4>
                                <ValidationProvider name="Item" rules="required" v-slot="{ errors }">
                                    
                                    <v-autocomplete
                                        @click="$parent.fn_getGodowns"
                                        @keyup.enter="$parent.fn_getGodowns"
                                        :items="$parent.godowns ? $parent.godowns : []"
                                        v-model="$parent.Form.selectedFromGodown"
                                        label="From Godown"
                                        placeholder=" "
                                        item-text="itemName"
                                        item-value="itemId"
                                        return-object
                                        :error-messages="errors"
                                        dense
                                        append>

                                        <v-list-item slot="prepend-item" class="primary--text" @click="$parent.fn_menuItemClick('fromgodown')">
                                            <v-list-item-title>Create New</v-list-item-title>
                                        </v-list-item>
                                    </v-autocomplete>
                                    
                                </ValidationProvider>
                              </v-flex>

                              <v-flex xs6 sm6 md6 form-item pt-4>
                                <ValidationProvider name="Item" rules="required" v-slot="{ errors }">
                                    
                                    <v-autocomplete
                                        @click="$parent.fn_getGodowns"
                                        @keyup.enter="$parent.fn_getGodowns"
              
                                        :items="$parent.godowns ? $parent.godowns : []"
                                        v-model="$parent.Form.selectedToGodown"
                                        label="To Godown"
                                        placeholder=" "
                                        item-text="itemName"
                                        item-value="itemId"
                                        return-object
                                        :error-messages="errors"
                                        dense
                                        append>

                                        <v-list-item slot="prepend-item" class="primary--text" @click="$parent.fn_menuItemClick('togodown')">
                                            <v-list-item-title>Create New</v-list-item-title>
                                        </v-list-item>
                                    </v-autocomplete>
                                    
                                </ValidationProvider>
                              </v-flex>
                        </v-layout>

                        <v-list two-line class="mt-2" nopadding>
                            <v-subheader>Add Item <v-spacer></v-spacer> <v-btn small color="primary" outlined round-borders text @click="$parent.fn_addProduct"><v-icon font20 color="primary" class="mr-2">add</v-icon> Add</v-btn></v-subheader>
                            <template v-for="(item, index) in $parent.Form.transactionProducts">  
                                <!-- <v-divider></v-divider>                 -->
                                <v-list-item :key="index">
                                    <v-list-item-content @click="$parent.fn_editItem(item, index)">
                                        <v-list-item-title>{{ item.productName }}</v-list-item-title>
                                        <!-- <v-list-item-subtitle>{{ item.qty }} {{ item.unitName }}</v-list-item-subtitle> -->
                                        <v-list-item-subtitle>{{ item.qty }} {{ item.unitName }} <template v-if="item.averageRate">x {{ $root.numberToLocale(item.averageRate) }}</template></v-list-item-subtitle>
                                      </v-list-item-content>
                                    <v-list-item-action @click="$parent.Form.transactionProducts.splice(index, 1)">
                                        <!-- <v-icon font20>delete</v-icon> -->
                                        <v-icon class="redcolor">remove_circle_outline</v-icon>
                                        <template v-if="item.averageRate">&#8377; {{ $root.numberToLocale(item.averageRate * item.qty) }}</template>
                                    </v-list-item-action>
                                </v-list-item>
                                <!-- <v-divider v-if="index != $parent.Form.transactionProducts.length - 1"></v-divider> -->
                            
                                <div class="grey-back full-width batch_display_container" v-if="item.batches && item.batches.length" :key="'batches' + index">

                                  <v-expansion-panels nomargin flat>

                                    <v-expansion-panel>

                                      <v-expansion-panel-header>
                                          <template>
                                              <v-subheader dense class="pa-0">{{item.selectedBatchType == 2 ? 'Series#' : 'Batches#'}}</v-subheader>
                                          </template>
                                      </v-expansion-panel-header>

                                      <v-expansion-panel-content>
                                        <!-- <div slot="header" light-opacity-color font16 class="pt-0 pb-0">{{ item.selectedBatchType == 2 ? 'Series#' : 'Batches#' }}</div> -->
                                        <v-card flat v-for="(batch, batchIndex) in item.batches" :key="batchIndex">

                                          <v-card-text class="pb-2 pt-2">
                                            <v-layout class="batch_layout ma-0" row wrap>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
                                                <div light-opacity-color>Batch No.</div>
                                                <div>{{ batch.batchNumber }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
                                                <div light-opacity-color>Size</div>
                                                <div>{{ batch.batchSize }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
                                                <div light-opacity-color>MRP</div>
                                                <div>{{ batch.batchMRP }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
                                                <div light-opacity-color>Mfg. Date</div>
                                                <div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
                                                <div light-opacity-color>Exp. Date</div>
                                                <div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
                                              </v-flex>
                                              <!-- <v-flex xs4 sm4 md4 mb-2>
                                                <div light-opacity-color>Opening</div>
                                                <div>{{ batch.opening ? batch.opening : 0  }}</div>
                                              </v-flex> -->
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
                                                <div light-opacity-color>Purchase Rate</div>
                                                <div>{{ batch.purchaseRate }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
                                                <div light-opacity-color>Serial Number</div>
                                                <div>{{ batch.field1 }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
                                                <div light-opacity-color>IMEI Number</div>
                                                <div>{{ batch.field2 }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
                                                <div light-opacity-color>Part Number</div>
                                                <div>{{ batch.field3 }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
                                                <div light-opacity-color>Model Number</div>
                                                <div>{{ batch.field4 }}</div>
                                              </v-flex>
                                              <v-flex xs4 sm4 md4 mb-2 v-if="item.selectedBatchType == 1 && (item.batches.length > 1 || item.batches.length == 1 && batch.productQty != item.qty)">
                                                <div light-opacity-color>Quantity</div>
                                                <div>{{ batch.productQty }}</div>
                                              </v-flex>
                                              <v-flex xs12 sm12 md12 redcolor pb-2 v-if="batch.expDate && $parent.fn_checkDate(batch)">
                                                <v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ $parent.fn_getDate(batch) }}
                                              </v-flex>
                                            </v-layout>
                                          </v-card-text>
                                          <v-divider v-if="item.batches.length - 1 != batchIndex"></v-divider>
                                        </v-card>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>

                                  </v-expansion-panels>

                                </div>
                              </template>
        
                        </v-list>

                        <!-- <v-list two-line class="mt-2 mb-2" nopadding v-if="$parent.Form.transactionProducts && $parent.Form.transactionProducts.length">
                        <v-subheader>Additional Charges 
                          <v-spacer></v-spacer> 

                          <v-menu v-model="$parent.chargesMenu" :max-height="400" :min-width="280" :max-width="280">
                          <template v-slot:activator="{ on, attrs }">

                            <v-btn color="primary" small text round-borders outlined v-bind="attrs" v-on="on"><v-icon class="primary-color font20 mr-2">add</v-icon> Add</v-btn>
                            
                          </template>

                          <v-list dense nopadding>
                            <v-list-item @click="$parent.fn_menuItemClick('addothercharges')">
                              <v-list-item-content>
                                <v-list-item-title class="primary-color">Create New</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-for="(item, index) in $parent.charges" :key="index" @click="$parent.fn_getAddonsData(item.itemId)">
                              <v-list-item-content>
                                <v-list-item-title medium-theme-color>{{item.itemName}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        </v-subheader>
                      

                        <template v-for="(item, index) in $parent.Form.transactionAddOns">  
                            <v-divider :key="index+'divider'"></v-divider>                
                            <v-list-item :key="index">
                              <v-list-item-action style="min-width:40px">
                                <v-btn icon @click="$parent.fn_removeAddOns(index)"><v-icon>close</v-icon></v-btn>
                              </v-list-item-action>
                              <v-list-item-content>
                                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action style="max-width: 100px;">
                                <v-text-field 
                                  class="right-align-textbox"
                                  v-model.number="item.value" 
                                  @input="item.percentage = null"  
                                  type="number" label="" 
                                  :prefix="item.nature ? '-' : ''">
                                </v-text-field>
                              </v-list-item-action>
                            </v-list-item>
                        </template>

                      <v-divider></v-divider>

                    </v-list> -->


                      <!-- <v-layout ma-0 grey-back row wrap white-back v-if="$parent.$parent.Form.trProducts.length">
                        <v-flex xs12 sm12 md12 right-align>
                            <v-btn light-opacity-color class="ma-3" capitalize outlined @click="$parent.fn_addMore">Add More</v-btn>
                          </v-flex>
                      </v-layout> -->
                        

                      <v-layout row wrap white-back ma-0 mt-2>

                            <v-flex sm12 md12 xs12 pa-4>
                              <ValidationProvider v-slot="{ errors }" name="Notes" rules="max:255">
                                <v-textarea
                                  rows="2"
                                  label="Notes" 
                                  auto-grow
                                  :counter="255"
                                  v-model="$parent.Form.transactionData.notes"
                                  :error-messages="errors">
                                </v-textarea>
                              </ValidationProvider>
                            </v-flex>
                        </v-layout>

                        <!-- <div white-background full-width nopadding white-back style="position:fixed;bottom:64px;" v-if="$parent.Form.transactionProducts && $parent.Form.transactionProducts.length">
                          <v-layout ma-0 row wrap>
                              <v-flex xs6 sm6 md6 pl-3 pt-2 pb-1>Total</v-flex>
                              <v-flex xs6 sm6 md6 pr-3 pt-2 pb-1 right-align>&#8377; {{ $root.numberToLocale($parent.totalAmount) }}</v-flex>
                          </v-layout>
                        </div> -->

                  </v-form>

                  </ValidationObserver>

                </template>

          </div>

          <!-- <div white-background full-width nopadding style="position:fixed;bottom:0;">
            <v-layout row wrap>
              <template v-if="$parent.totalAmount">
                <template v-if="$parent.batchTotalQty">
                  <v-flex xs6 sm6 md6 pl-3 pt-2 pb-1 style="text-align:left">Batch Total Opening</v-flex>
                      <v-flex xs6 sm6 md6 pr-3 pt-2 pb-1 style="text-align:right">{{$parent.batchTotalQty}} {{$parent.$parent.Form.selectedUnit ? $parent.$parent.Form.selectedUnit.itemName : $parent.$parent.Form.trProducts[0].variants[0].unitName }}</v-flex>
                </template>
                <v-flex xs4 sm4 md4 pl-3 pb-2 style="text-align:left">Total Amount</v-flex>
                    <v-flex xs8 sm8 md8 pr-3 pb-2 style="text-align:right">&#8377; {{$parent.totalAmount ? $root.numberToLocale($parent.totalAmount) : $parent.totalAmount}}</v-flex>
              </template>
              <v-flex xs12 sm12 md12 height48>
                <v-btn color="primary" full-height nomargin block no-round-borders :disabled="$parent.disableBtn" noshadow @click="$parent.fn_checkValidations">Save</v-btn>
              </v-flex>
            </v-layout>
          </div> -->

          <v-card-actions white-back>
              <v-layout row wrap ma-0>
                  <template v-if="$parent.totalAmount">
                    <v-flex xs4 sm4 md4 pt-2 pb-2 style="text-align:left">Total</v-flex>
                    <v-flex xs8 sm8 md8 pt-2 pb-2 style="text-align:right">&#8377; {{$parent.totalAmount ? $root.numberToLocale($parent.totalAmount) : $parent.totalAmount}}</v-flex>
                  </template>

                  <v-flex xs12 sm12 md12 height48>
                      <v-btn class="save_btn" no-border-radius color="primary" full-height nomargin block no-round-borders noshadow :disabled="$parent.disableOnSave" :key="$parent.saveBtnKey" @click="fn_validateForm">Save</v-btn>
                  </v-flex>

              </v-layout>
          </v-card-actions>
                  

          </v-card>

          <v-snackbar v-model="$parent.transactionNumberSnackbar" right vertical :timeout="0">
              Generate new transaction number?

              <template v-slot:action="{ attrs }">

                  <v-btn text @click="$parent.transactionNumberSnackbar = false" color="warning">Close</v-btn>

                  <v-btn class="ml-2" text @click="$parent.fn_getNumberSeries" v-bind="attrs" color="primary">Okay</v-btn>

              </template>
          </v-snackbar>
        </v-dialog>
    </div>
</template>

<script>
// import gstrSubReport from '../print_report_templates/gstr_sub_report'
import { numeric, min_value, max } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
// setInteractionMode('eager')

// extend('required', {
//   ...required,
//   message: '{_field_} can not be empty',
// })

extend('min_value', {
    ...min_value,
    message: 'This field must be 0 or more.'
});

extend('max', max)

extend('decimal2', value => {

  let decimalCount = 0;
  if(Math.floor(value) != value){
     decimalCount = value.toString().split(".")[1].length || 0;
  }

  if(decimalCount <= 2){
    return true;
  }

  return 'This field must be numeric and may contain 2 decimal points.';

});

extend('numeric', {
    ...numeric,
   message: 'This field may only contain numeric characters.' 
});

    export default{
        props:['closeDialog'],
        data(){
            return{
                dialog_form: false,
            }
        },
        components:{
            // 'gstr-sub-report':gstrSubReport
            ValidationProvider,
            ValidationObserver
        },
        methods:{
            openDialogWeb: function () {
                this.dialog_form = true;
            },
            closeDialogWeb: function () {
                this.dialog_form = false;
            },
            fn_validateForm: function(){
              this.$parent.disableOnSave = true;
              this.$refs.observer.validate().then((result) => {
                if(result) {

                  // if(this.$root.TransactionSettings.enableBatch && this.$parent.$parent.Form.batches && this.$parent.$parent.Form.batches.length){
                  //   let batchTotal = 0;
                  //   for(let i=0; i<this.$parent.$parent.Form.batches.length; i++){
                  //     batchTotal += this.$parent.$parent.Form.batches[i].opening;
                  //   }
                  //   let openingQty = this.$parent.$parent.Form.trProducts[0].variants[0].qty ? this.$parent.$parent.Form.trProducts[0].variants[0].qty : 0; 
                  //   if(openingQty != batchTotal){
                  //     this.$parent.saveBtnKey++;
                  //     this.$parent.disableOnSave = false;
                  //     this.$eventHub.$emit('snackbarAlert', {msg:"Opening quantity not matched with batch total opening"});
                  //     return;
                  //   }
                  // }

                  this.$parent.fn_checkValidations();
                }
                else{
                  this.$parent.saveBtnKey++;
                  this.$parent.disableOnSave = false;
                  this.fn_scrollToElement('error--text');
                }
              });
            },
            fn_new: function(){
              this.closeDialogWeb();
              setTimeout(()=>{
                this.$router.push({path:'/'+this.$route.params.businessId + '/' + this.$route.params.listId +'/product/items/new', query:{tagId:this.guidWeb(), ls:1}});
              },100);
            },

            fn_unitChange: function(value, item, product){
              let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
              if(currentItemId != value.itemId){
                if(value.itemId == item.secondaryUnitId){
                  product.rate = (product.rate * item.packQuantity) / item.secondaryUnitPackQuantity;
                }
                else{
                  product.rate = (product.rate * item.secondaryUnitPackQuantity) / item.packQuantity;
                  // product.rate = this.roundUpto2Decimals(product.rate * item.secondaryUnitPackQuantity);
                }
                // this.tempRate = product.rate;
                product.rate = this.roundUpto2Decimals(product.rate); 
              }
            },
        }
    }
</script>